import { forwardRef, type HTMLAttributes, type ForwardedRef, type ReactNode } from 'react';
import { cn } from '../lib/cn';

export interface MetricPillProps extends HTMLAttributes<HTMLSpanElement> {
  icon?: ReactNode;
  label: string;
  value: ReactNode;
}

export const MetricPill = forwardRef(function MetricPill(
  { className, icon, label, value, ...props }: MetricPillProps,
  ref: ForwardedRef<HTMLSpanElement>,
) {
  return (
    <span
      ref={ref}
      className={cn(
        'inline-flex h-8 items-center gap-2 rounded-md border border-border bg-card px-2.5 text-[12px] text-foreground',
        className,
      )}
      {...props}
    >
      {icon ? <span className="flex items-center text-muted-foreground">{icon}</span> : null}
      <span className="font-mono text-[10px] uppercase tracking-[0.12em] text-muted-foreground">{label}</span>
      <span className="font-mono text-[11px] text-foreground">{value}</span>
    </span>
  );
});
